import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

import { Event } from '../../../../../../entities/Event'

import './EventInfo.css'

const EventInfo = ({ event }) => (
    <div className="event__info">
        <div className="event__info__date">
            <img src="/images/calendar.png" alt="date" />
            <div>{event.displayDateAndTime}</div>
        </div>
        <div className="event__info__location">
            <img src="/images/location.png" alt="location" />
            <Link to="#">{event.locationAddress}</Link>
        </div>
    </div>
)

EventInfo.propTypes = {
    event: PropTypes.instanceOf(Event).isRequired
}

export { EventInfo }
